// ECOM MODALS
export const ONE_CLICK_BUY = 'one_click_buy';
export const PREORDER = 'preorder';
export const CREDIT = 'credit';
export const SERVICE_CENTER = 'service_center';
export const CAREER = 'career';
export const NEWSLETTER = 'newsletter';
export const SUCCESS_AFTER_ONE_CLICK_BUY = 'success_after_one_click_buy';
export const SUCCESS_AFTER_PREORDER = 'success_after_preorder';
export const SUCCESS_AFTER_CREDIT = 'success_after_credit';
export const SUCCESS_AFTER_SERVICE_CENTER = 'success_after_service_center';
export const SUCCESS_AFTER_CART = 'success_after_cart';
export const RESTORE_PASSWORD = 'restore_password';
export const SUCCESS_RESTORE_PASSWORD = 'success_restore_password';
export const RECOVERY_PASSWORD = 'recovery_password';
export const AUTHORIZATION = 'authorization';
export const REGISTER = 'register';
export const MODAL_REGISTER_SUCCESS = 'modal_register_success';
export const MODAL_ADDED_TO_CART_NOTIFICATION = 'modal_added_to_cart_notification';
export const MODAL_ADDED_TO_FAVORITES_NOTIFICATION = 'modal_added_to_favorites_notification';
export const MODAL_ADDED_TO_COMPARE_NOTIFICATION = 'modal_added_to_compare_notification';
export const MODAL_AGE_RESTRICTION = 'modal_age_restriction';
export const MODAL_REQUEST_PROFILE_DELETE = 'modal_request_profile_delete';
export const MODAL_CONFIRM_PROFILE_DELETE_MESSAGE = 'modal_confirm_profile_delete_message';
export const MODAL_PROFILE_DELETE_SUCCESS = 'modal_profile_delete_success';
export const MODAL_CHECKOUT = 'modal_checkout';
export const MODAL_FIRST_TO_KNOW = 'modal_first_to_know';
export const MODAL_SUCCESS_FIRST_TO_KNOW = 'modal_success_first_to_know';

// NOVAPORTA MODALS
export const MODAL_ASK_SPECIALIST_NOVAPORTA = 'modal_ask_specialist_novaporta';
export const MODAL_SEND_PRODUCT_REVIEW_NOVAPORTA = 'modal_send_product_review_novaporta';

// ECATERIX MODALS
export const MODAL_REQUEST_ECATERIX = 'modal_request_ecaterix';
export const MODAL_VACANCY_ECATERIX = 'modal_vacancy_ecaterix';
